import { mapActions, mapState } from 'vuex';
import SignDocument from '../SignDocument/SignDocument.vue';

export default {
  components: { SignDocument },
  data() {
    var validateImage = (rule, value, callback) => {
      // if (value.length > 0 && value[0].raw.type.match(/image/)) {
      //   callback(new Error('Ви можете вибрати лише зображення'));
      // } else if (
      //   value.length > 0 &&
      //   this.bytesToMegaBytes(value[0].size) > 20
      // ) {
      //   callback(new Error('Розмір файлу не повинен бути більшим 20Мб'));
      // } else {
        callback();
      // }
    };

    return {
      documentsForm: {
        applicationFile: [],
        passportFiles: [],
        codeFile: [],
        propertyRigthFiles: [],
        applicationCopy: [],
      },
      showSignDocument: false,
      documentsUploading: false,
      documents: [],
      documentsValidation: {
        applicationFile: [
          {
            validator: (rule, value, callback) => {
              var _validFileExtensions = ['.p7s'];
              if (
                value.length > 0 &&
                !this.hasExtension(value[0].raw.name, _validFileExtensions) &&
                value[0].raw.type === 'application/pkcs7-signature'
              ) {
                callback(
                  new Error('Заявка повинна бути підписана за допомогою ЕКП')
                );
              } else if (value.length > 0 && this.bytesToMegaBytes(value[0].size) > 1) {
                callback(new Error('Розмір файлу не повинен бути більшим 1Мб'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
          {
            required: true,
            message: "Документ є обов'язковим для надсилання",
            trigger: 'blur',
          },
        ],
        passportFiles: [
          {
            validator: validateImage,
            trigger: 'change',
          },
          {
            required: true,
            message: "Документ є обов'язковим для надсилання",
            trigger: 'blur',
          },
        ],
        codeFile: [
          {
            validator: validateImage,
            trigger: 'change',
          },
          {
            required: true,
            message: "Документ є обов'язковим для надсилання",
            trigger: 'blur',
          },
        ],
        propertyRigthFiles: [
          {
            validator: validateImage,
            trigger: 'change',
          },
          {
            required: true,
            message: "Документ є обов'язковим для надсилання",
            trigger: 'blur',
          },
        ],
        applicationCopy: [
          {
            validator: validateImage,
            trigger: 'change',
          },
          {
            required: true,
            message: "Документ є обов'язковим для надсилання",
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      eisCode: (state) => state.Applications.application.eisCode,
      applicationData: (state) => state.Applications.application,
      applicationBlob: (state) => state.Applications.applicationBlob,
      signedApplicationBlob: (state) =>
        state.Applications.signedApplicationBlob,
    }),
  },
  methods: {
    ...mapActions(['uploadDocuments', 'setApplicationData', 'setActiveTab']),
    bytesToMegaBytes(bytes) {
      return bytes / (1024 * 1024);
    },
    submitDocuments() {
      this.$refs.documentsForm.validate((valid) => {
        if (valid) {
          this.documentsUploading = true;
          let formData = new FormData();
          formData.append('eisCode', this.eisCode);
          this.documents = [
            ...this.documentsForm.applicationFile,
            ...this.documentsForm.passportFiles,
            ...this.documentsForm.codeFile,
            ...this.documentsForm.propertyRigthFiles,
            ...this.documentsForm.applicationCopy,
            ...[
              {
                name: 'Заява_Приєднання.pdf',
                url: URL.createObjectURL(this.applicationBlob),
                raw:  new File([this.applicationBlob], 'Заява_Приєднання.pdf', {
                  type: 'application/pdf',
                }),
              },
            ],
          ].map((file, i) => {
            formData.append(`documents[${i}]`, file.raw);
          });

          formData.append('application', JSON.stringify(this.applicationData));

          this.uploadDocuments(formData)
            .then(() => {
              this.$notify.success({
                title: 'Вітаємо',
                message: 'Документи успішно відправлено.',
              });
              // this.$refs.documentsForm.resetFields();
              this.documentsUploading = false;
              this.setActiveTab('applicationStatus');
            })
            .catch(() => {
              this.documentsUploading = false;
            });
        }
      });
    },
    onApplicationFileChange(file, fileList) {
      this.documentsForm.applicationFile = fileList;
    },
    onApplicationRemove() {
      this.documentsForm.applicationFile = [];
    },
    onPassportFileChange(file, fileList) {
      this.documentsForm.passportFiles = fileList;
    },
    onCodeFileChange(file, fileList) {
      this.documentsForm.codeFile = fileList;
    },
    onPropertyRigthChange(file, fileList) {
      this.documentsForm.propertyRigthFiles = fileList;
    },
    eisCodeSubmit(eisCode) {
      this.setApplicationData({ eisCode });
    },
    onApplicationCopyFileChange(fileCopy, fileList) {
      this.documentsForm.applicationCopy = fileList;
    },
    hasExtension(fileName, exts) {
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      );
    },
    signApplication() {
      this.showSignDocument = true;
    },
    downloadApplication() {
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(this.applicationBlob);
      downloadLink.download = 'Заява_Приєднання.pdf';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    onSignHandler() {
      this.documentsForm.applicationFile = [
        {
          name: 'Заява_Приєднання_З_Підписом.pdf.p7s',
          url: URL.createObjectURL(this.signedApplicationBlob),
          raw: new File(
            [this.signedApplicationBlob],
            'Заява_Приєднання_З_Підписом.pdf.p7s'
          ),
        },
      ];
    },
  },
};
